import React, { useEffect } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import MasterLayout from './Layouts/MasterLayout';
import { AuthInit } from './Contexts/auth.context';
import ScrollToTop from './components/scrolltop/scrolltop.component';
import Cookies from 'js-cookie';
import { ToastContainer } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css';

function App() {
  useEffect(() => {
    const referrer = document.referrer;
    Cookies.set('referrer', referrer, { expires: 7 });
  }, []);

  useEffect(() => {
    localStorage.removeItem('hasForcedReload');
  }, []);

  return (
    <AuthInit>
      <ScrollToTop />
      <MasterLayout />
      <ToastContainer />
    </AuthInit>
  );
}

export default App;

